"use client";
import { useStore } from "@core/store";
import { IUser } from "@core/types/requests/welcome";
import { fetcherAlegriia } from "@utils/requests";
import { AxiosError } from "axios";
import { useRouter } from "next/navigation";
import { useEffect, useMemo } from "react";
import useSWR from "swr";
import { useShallow } from "zustand/react/shallow";

export const useUser = () => {
  const router = useRouter();

  const { token, cleanToken } = useStore(
    useShallow((state) => ({
      token: state.token,
      cleanToken: state.cleanToken,
    }))
  );

  const { data, error, mutate, isLoading } = useSWR<IUser>(
    token && { url: "/welcome", auth: token },
    fetcherAlegriia
  );
  useEffect(() => {
    if (
      !isLoading &&
      (error as AxiosError)?.response?.status === 401 &&
      cleanToken
    ) {
      router.replace("/");
      cleanToken();
      return;
    }
    if (!data?.verified && !isLoading && !!token)
      return router.push("/verify-email?i=1");
    if (data?.shouldChangePassword && !isLoading && !!token)
      return router.push("/validate-info");
  }, [router, token, isLoading, error, cleanToken, data]);

  return useMemo(
    () => ({
      token,
      ...data,
      email: data?.email ?? error?.response?.data?.email,
      mutate,
      isLoading,
    }),
    [token, data, error, mutate, isLoading]
  );
};
